import { useEffect, useState } from 'react';
import { Route, Routes, useLocation,Navigate } from "react-router-dom";
import Dashboard from "../pages/Dashboard";
import Profile from '../pages/profile/Profile';
import Login from "@pages/Login";
import DeleteAccount from "@pages/DeleteAccount";
import ForgotPassword from '@pages/ForgotPassword';
import Register from '@pages/Register';
import RegisterMobile from '@pages/RegisterMobile';
import CreateApplication from "@pages/insurance";
import LeadList from '@pages/insurance/list/InsuranceList';
import Header from "@common/Header";
import PrivateRoute from '@src/routes/privateRoute';
import ClaimList from '@pages/claims/list/ClaimList';
import PaymentAddEdit from "@pages/payment/PaymentAddEdit";
import QuoteDetails from "@pages/QuoteDetails";
import NotFound from '@src/common/NotFound';
import { getPublicKey } from '@src/store/slices/encryption';
import mappingAgencyList from "../pages/mappingAgency/mappingAgencyList"
import { isMobile } from 'react-device-detect';
import DashboardID from "../pages/DashboardID";
import CommissionList from '@pages/commission/commissionList';
import SupportList from '@pages/dashboard-id/SupportList';
import FaqList from '@pages/dashboard-id/FaqList';
import { COUNTRY_CODE } from '@src/config/constant';
import CreateApplicationId from '@pages/insurance/create';
import GeneratePaymentLink from '@pages/insurance/create/GeneratePaymentLink';
import AgentCommissionChangePage from '@pages/insurance/list/AgentCommissionChangePage'
import GeneratePaymentLinkApp from '@pages/insurance/create/GeneratePaymentLinkApp';
import RegisterSlider from '@pages/register/RegisterSlider';
import BackOrderDocUpload from '@pages/insurance/back-order/BackOrderDocUpload';

const isCountryId = COUNTRY_CODE ==='id' ? true : false;



export default function AppRoutes() {
    const location = useLocation()
    let currentPath = location.pathname;

    const [loadRoutes, setLoadRoutes] = useState(true)

    useEffect(()=>{

        getPublicKey().then((res: any)=> {
            if(res?.data) setLoadRoutes(true)
        })

    },[])

    return (
        <>
            {
                !["/", "", "/login","/signup/start","/register","/not-found","/forgot-password","/delete/account", "/not-found", "/readOcrDocument"].includes(currentPath) && <Header />
            }
            {
                loadRoutes && <Routes>
                    <Route path="/" element={<Login />} />
                    <Route path="/signup/start" element={<RegisterSlider />} />
                    <Route path="/register" element={<Register />} />
                    
                    <Route path="/login" element={<Login />} />
                    <Route path="/forgot-password" element={<ForgotPassword />} />
                    <Route path="/delete/account" element={<DeleteAccount />} />
                    <Route path="/dashboard" element={<PrivateRoute component={Dashboard} />} />          
                    <Route path="/my-profile" element={<PrivateRoute component={Profile} />} />
                    <Route path="/create-insurance-policy" element={<PrivateRoute component={isCountryId?CreateApplicationId:CreateApplication} />} />
                    <Route path="/create-insurance-policy/:id" element={<PrivateRoute component={isCountryId?CreateApplicationId:CreateApplication} />} />
                    <Route path="/insurance-list" element={<PrivateRoute component={LeadList} />} />
                    <Route path="/claim-list" element={<PrivateRoute component={ClaimList} />} />

                    <Route path="/payment-add/:id" element={<PrivateRoute component={PaymentAddEdit} />} />
                    <Route path="/quote-details/:id" element={<PrivateRoute component={QuoteDetails} />} />
                   <Route path="/mapping-agency-list" element={<PrivateRoute component={mappingAgencyList} />} />
                    <Route path="*" element={<Navigate to="/not-found"/>} />
                    <Route path="/not-found" element={<NotFound/>} /> 

                    <Route path="/dashboardID" element={<PrivateRoute component={DashboardID} />} />                   
                    <Route path="/commission-list" element={<PrivateRoute component={CommissionList} />} />                   
                    <Route path="/support-list" element={<PrivateRoute component={SupportList} />} />                   
                    <Route path="/faq-list" element={<PrivateRoute component={FaqList} />} />    
                    <Route path="/generate-payment-link/:id" element={<PrivateRoute component={GeneratePaymentLink} />} />
                    <Route path="/generate-payment-link-app/:id" element={<PrivateRoute component={GeneratePaymentLinkApp} />} />  
                    <Route path="/agentCommssion-list" element={<PrivateRoute component={AgentCommissionChangePage} />} />
                    <Route path="/back-order-application/:leadId" element={<PrivateRoute component={BackOrderDocUpload} />} />
                </Routes>
            }

        </>
    )
}